import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const AttachmentContext = createContext(null)

export function AttachmentProvider ({ children, threadId }) {
  const [selectedAttachment, setSelectedAttachment] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const previousThreadIdRef = useRef(threadId)

  // Close attachment when thread changes
  useEffect(() => {
    if (threadId !== previousThreadIdRef.current && isOpen) {
      setIsOpen(false)
      setSelectedAttachment(null)
    }
    previousThreadIdRef.current = threadId
  }, [threadId, isOpen])

  // Open an attachment
  const openAttachment = useCallback((attachment) => {
    setSelectedAttachment(attachment)
    setIsOpen(true)
  }, [])

  // Close the attachment viewer
  const closeAttachment = useCallback(() => {
    setIsOpen(false)
    // Delay clearing attachment for exit animation
    setTimeout(() => setSelectedAttachment(null), 300)
  }, [])

  const value = {
    selectedAttachment,
    isOpen,
    openAttachment,
    closeAttachment
  }

  return (
    <AttachmentContext.Provider value={value}>
      {children}
    </AttachmentContext.Provider>
  )
}

AttachmentProvider.propTypes = {
  children: PropTypes.node,
  threadId: PropTypes.string
}

export function useAttachment () {
  const context = useContext(AttachmentContext)
  if (!context) {
    throw new Error('useAttachment must be used within an AttachmentProvider')
  }
  return context
}
